import { IUser } from 'rt/UIApiControllers/Authentication/IUser';

class LicenseHelper {
    static isStandard(user: IUser): boolean {
        return user.licence.startsWith('A-S');
    }

    static isCRMDelSol(user: IUser): boolean {
        return user.licence.startsWith('SDS-');
    }

    static isTurkish(user: IUser): boolean {
        return user.licence.startsWith('TUR-');
    }
}

export default LicenseHelper;
